export default __webpack_public_path__ + "static/media/LogoAQ.deb52e5c.png";